const { configJson } = require('../rcs_gaz_mc_core_FE');

class ConfigManager {
  static getEnv() {
    configJson.urlToUse = process.env.REACT_APP_ENV;
    return process.env.REACT_APP_ENV;
  }

  static getContextRoot() {
    return configJson.endpoints[this.getEnv()];
  }

  static getServiceInfo(group, serviceName) {
    const serviceObject = configJson.serviceCollection[group][serviceName];
    return serviceObject;
  }

  static getApiVersion() {
    return configJson.apiVersion;
  }

  static getConstants() {
    return configJson.constants;
  }

  static buildUrl(contextRoot, apiName, urlParameters) {
    urlParameters.version = this.getApiVersion();
    return `${contextRoot}${apiName(urlParameters)}`;
  }

  static getSportRefreshInterval(sportId) {
    return configJson.sportRefreshInterval[sportId];
  }

  static getLanguageDictionary() {
    return configJson.dictionary[configJson.language];
  }

  static getRoute(routeName, site) {
    if (site === 'corriere') {
      if (routeName === 'hublive') {
        routeName = 'hubliveCorriere';
      }
      if (routeName === 'favourites') {
        routeName = 'favouritesCorriere';
      }
    } else if (site === 'forzaroma' || site === 'fcinter' || site === 'calcionapoli1926') {
      if (routeName === 'hublive') {
        routeName = 'hubliveGazzanet';
      }
      if (routeName === 'favourites') {
        routeName = 'favouritesGazzanet';
      }
    }
    const routeObject = configJson.routes[routeName];
    return routeObject[this.getEnv()]();
  }

  static getFootballTeams(res) {
    return configJson.imageUrls.football.teams[res];
  }

  static getCountriesFlag() {
    return configJson.imageUrls.countriesFlag;
  }

  static getBasketTeams(res) {
    return configJson.imageUrls.basket.teams[res];
  }
}

export default ConfigManager;
